import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const PrivacyPolicy = () => {
  return (
    <Container className="py-5">
      <Row className="mb-5">
        <Col>
          <h1 className="text-center mb-4">Privacy Policy</h1>
          <p className="text-muted text-center">Last updated: February 21, 2025</p>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <h2>1. Introduction</h2>
          <p>
            Welcome to our Privacy Policy. Your privacy is critically important to us. 
            This Privacy Policy explains how we collect, use, disclose, and safeguard your information 
            when you visit our website and use our services.
          </p>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <h2>2. Information We Collect</h2>
          <h3 className="h4 mb-3">2.1 Personal Information</h3>
          <p>
            We may collect personal information that you voluntarily provide to us when you:
          </p>
          <ul className="mb-4">
            <li>Register on our website</li>
            <li>Make a purchase</li>
            <li>Contact us for support</li>
          </ul>

          <h3 className="h4 mb-3">2.2 Automatically Collected Information</h3>
          <p>
            When you visit our website, we automatically collect certain information about your device, including:
          </p>
          <ul>
            <li>IP address</li>
            <li>Browser type</li>
            <li>Operating system</li>
            <li>Access times</li>
          </ul>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <h2>3. How We Use Your Information</h2>
          <p>
            We use the information we collect to:
          </p>
          <ul className="mb-4">
            <li>Provide, maintain, and improve our services</li>
            <li>Process your transactions</li>
            <li>Respond to your comments and questions</li>
            <li>Protect against fraudulent or illegal activity</li>
          </ul>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <h2>4. Information Sharing</h2>
          <p>
            We do not sell, trade, or otherwise transfer your personal information to third parties 
            without your consent, except in the following circumstances:
          </p>
          <ul>
            <li>To comply with legal obligations</li>
            <li>To protect our rights and property</li>
            <li>To prevent or investigate possible wrongdoing</li>
            <li>With service providers who assist in our operations</li>
          </ul>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <h2>5. Data Security</h2>
          <p>
            We implement appropriate technical and organizational security measures to protect your 
            personal information. However, no method of transmission over the Internet or electronic 
            storage is 100% secure, and we cannot guarantee absolute security.
          </p>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <h2>6. Your Rights</h2>
          <p>
            You have the right to:
          </p>
          <ul>
            <li>Access your personal information</li>
            <li>Correct inaccurate information</li>
            <li>Request deletion of your information</li>
            <li>Object to our processing of your information</li>
            <li>Withdraw consent at any time</li> 
          </ul>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <h2>7. Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy or our practices, please contact us:
          </p>
          <p><a href="/contact">Contact Us</a></p>
        </Col>
      </Row>

      <Row>
        <Col>
          <hr />
          <p className="text-muted text-center">
            This privacy policy is subject to change without notice and was last updated on the date 
            listed above. If you have any questions about our Privacy Policy, please contact us.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default PrivacyPolicy;